<ng-container *transloco="let translated">
  <div [formGroup]="formGroup">
    @for (typeUser of ACCOUNT_TYPES; track typeUser.id) {
    <label [for]="typeUser.id" class="btn btn-outline-default mr-2 w-100">
      <div class="custom-control custom-radio text-left">
        <input
          type="radio"
          formControlName="typeAccount"
          [value]="typeUser.key"
          class="custom-control-input my-custom-control-input"
          name="typeAccount"
          [id]="typeUser.id"
        />
        <label
          [for]="typeUser.id"
          class="custom-control-label my-custom-control-label cursor-pointer"
          >{{ translated(typeUser.displayText) }}</label
        >
      </div>
    </label>
    }
  </div>
</ng-container>
